module.exports = __webpack_public_path__ + "img/educacao-infantil-sistema-cpv.f59d137f.png";